import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'authorize',
    loadComponent: () =>
      import('./pages/authorize/authorize.component').then(
        (m) => m.AuthorizeComponent
      ),
  },
  {
    path: 'callback/:provider',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'callback-app/:provider',
    loadComponent: () =>
      import('./pages/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'sign-up',
    loadComponent: () =>
      import('./pages/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/sign-up/sign-up.component').then(
            (m) => m.SignUpComponent
          ),
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./pages/profile/profile.component').then(
            (m) => m.ProfileComponent
          ),
      },
      {
        path: 'personal-data-confirmation',
        loadComponent: () =>
          import('./components/personal-data-confirmation/personal-data-confirmation.component').then(
            (m) => m.PersonalDataConfirmationComponent
          ),
      },
      {
        path: 'success',
        loadComponent: () =>
          import('./pages/sign-up-success/sign-up-success.component').then(
            (m) => m.SignUpSuccessComponent
          ),
      },
    ],
  },
  {
    path: 'change-account',
    loadComponent: () =>
      import('./pages/change-account/change-account.component').then(
        (m) => m.ChangeAccountComponent
      ),
  },
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./pages/onboarding/onboarding.component').then(
        (m) => m.OnboardingComponent
      ),
    children: [
      { path: '', redirectTo: 'landscape', pathMatch: 'full' },
      {
        path: 'landscape',
        loadComponent: () =>
          import('./pages/favorite-landscape/favorite-landscape.component').then(
            (m) => m.FavoriteLandscape
          ),
      },
      {
        path: 'activity',
        loadComponent: () =>
          import('./pages/favorite-activity/favorite-activity.component').then(
            (m) => m.FavoriteActivity
          ),
      },
      {
        path: 'redirect',
        loadComponent: () =>
          import('./pages/redirect/redirect.component').then(
            (m) => m.RedirectComponent
          ),
      },
    ],
  },
  {
    path: 'recover',
    loadComponent: () =>
      import('./pages/recover/recover.component').then(
        (m) => m.RecoverComponent
      ),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/recover-password/recover-password.component').then(
            (m) => m.RecoverPasswordComponent
          ),
      },
      {
        path: 'mail-send',
        loadComponent: () =>
          import('./pages/recover-mail-send/recover-mail-send.component').then(
            (m) => m.RecoverMailSendComponent
          ),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('./pages/reset-password/reset-password.component').then(
            (m) => m.ResetPasswordComponent
          ),
      },
      {
        path: 'password-changed',
        loadComponent: () =>
          import('./pages/reset-password-confirmation/reset-password-confirmation.component').then(
            (m) => m.ResetPasswordConfirmationComponent
          ),
      },
    ],
  },
  {
    path: 'delete-account',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/delete-account/delete-account.component').then(
            (m) => m.DeleteAccountComponent
          ),
      },
      {
        path: 'confirmation',
        loadComponent: () =>
          import('./pages/delete-account-confirmation/delete-account-confirmation.component').then(
            (m) => m.DeleteAccountConfirmationComponent
          ),
      },
    ],
  },

  {
    path: 'logout',
    loadComponent: () =>
      import('./components/logout/logout.component').then(
        (m) => m.LogoutComponent
      ),
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
  },
];
